import { blue } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';
import { ChipField } from 'shared/react-admin/Fields';
import { getColumnStyle } from 'utils';

const trimmedStrStyle = {
  'a, span': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export const StyledDatagrid = styled(DatagridWithStickyActions)({
  '& .column-company': getColumnStyle(161),
  '& .column-provider': getColumnStyle(167),
  '& .column-workTeam': getColumnStyle(164),
  '& .column-workTeamLead': getColumnStyle(180),
  '& .column-users': getColumnStyle(144),
  '& .column-merchants': {
    ...getColumnStyle(191),
    ...trimmedStrStyle,
  },
  '& .column-merchantAccounts': {
    ...trimmedStrStyle,
  },
  '& .MuiTableCell-paddingCheckbox': {
    width: '1%',
    minWidth: '56px',
    padding: '13px 16px',
  },
  '&& .RaBulkActionsToolbar-toolbar:not(.RaBulkActionsToolbar-collapsed)': {
    height: '48px',
  },
});

export const StyledSpanField = styled(Box)({
  cursor: 'pointer',
  color: blue[700],
  textDecoration: 'underline',
});

export const StyledChipField = styled(ChipField)({
  '& .MuiChip-label': {
    color: blue[700],
  },
});
